import { render } from "./EventCardSkeleton.vue?vue&type=template&id=b67b7ec2&scoped=true"
import script from "./EventCardSkeleton.vue?vue&type=script&lang=js"
export * from "./EventCardSkeleton.vue?vue&type=script&lang=js"

import "./EventCardSkeleton.vue?vue&type=style&index=0&id=b67b7ec2&lang=css&scoped=true"

import exportComponent from "/var/www/test.mciafc.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b67b7ec2"]])

export default __exports__